import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Logo from "../assets/logo.png";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../hooks/index";
import { EN, VI } from "../common/text";

const NavBar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [langAnchorEl, setLangAnchorEl] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();
  const location = useLocation();

  const handleClick = (path) => {
    navigate(path);
    setAnchorEl(null);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLangMenuOpen = (event) => {
    setLangAnchorEl(event.currentTarget);
  };

  const handleLangMenuClose = () => {
    setLangAnchorEl(null);
  };

  const handleLanguageChange = (lang) => {
    sessionStorage.setItem("location", lang);
    setLanguage(lang);
    handleLangMenuClose();
    navigate(window.location.pathname, { replace: true });
  };

  const navLinks = [
    { path: "/home", label: t("nav.home"), icon: "fas fa-home" },
    { path: "/terms", label: t("nav.terms"), icon: "fas fa-file-alt" },
    { path: "/privacy", label: t("nav.privacy"), icon: "fas fa-lock" },
    { path: "/news", label: t("nav.news"), icon: "fas fa-newspaper" },
    { path: "/contact", label: t("nav.contact"), icon: "fas fa-envelope" },
    {
      path: "/announcement",
      label: t("nav.announcement"),
      icon: "fas fa-bullhorn",
    },
  ];

  return (
    <>
      <div style={{ height: "64px" }}></div>

      <AppBar position="fixed" sx={{ background: "white" }}>
        <Toolbar>
          {/* Logo bên trái */}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <img
              src={Logo}
              alt="logo"
              style={{ width: "60px", height: "40px", objectFit: "cover" }}
            />
          </Typography>

          {/* Điều hướng hiển thị trên Desktop */}
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Button
                  key={link.path}
                  color="inherit"
                  onClick={() => handleClick(link.path)}
                  sx={{
                    fontWeight: isActive ? "bold" : "normal",
                    backgroundColor: isActive ? "#f0f0f0" : "transparent",
                    borderRadius: "5px",
                  }}
                >
                  <strong style={{ color: isActive ? "blue" : "black" }}>
                    {link.label}
                  </strong>
                </Button>
              );
            })}
          </Box>

          {/* Box chứa icon menu & icon ngôn ngữ */}
          <Box
            sx={{ display: "flex", alignItems: "center", marginLeft: "auto" }}
          >
            {/* Icon Menu (3 chấm) - Mobile */}
            <Box sx={{ display: { xs: "block", md: "none" } }}>
              <IconButton
                size="large"
                edge="end"
                onClick={handleMenuOpen}
                color="black"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {navLinks.map((link) => {
                  const isActive = location.pathname === link.path; // Kiểm tra pathname
                  return (
                    <MenuItem
                      key={link.path}
                      onClick={() => handleClick(link.path)}
                      sx={{
                        fontWeight: isActive ? "bold" : "normal",
                        backgroundColor: isActive ? "#f0f0f0" : "transparent",
                      }}
                    >
                      {link.label}
                    </MenuItem>
                  );
                })}
              </Menu>
            </Box>

            {/* Icon chọn ngôn ngữ 🌐 (nằm cuối) */}
            <Box>
              <IconButton
                size="large"
                edge="end"
                onClick={handleLangMenuOpen}
                color="black"
              >
                🌐
              </IconButton>
              <Menu
                anchorEl={langAnchorEl}
                open={Boolean(langAnchorEl)}
                onClose={handleLangMenuClose}
              >
                <MenuItem
                  onClick={() => handleLanguageChange(VI)}
                  sx={{ fontWeight: language === VI ? "bold" : "normal" }}
                >
                  🇻🇳 Tiếng Việt
                </MenuItem>
                <MenuItem
                  onClick={() => handleLanguageChange(EN)}
                  sx={{ fontWeight: language === EN ? "bold" : "normal" }}
                >
                  🇺🇸 English
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default NavBar;
